import { Pipe, PipeTransform } from '@angular/core';
import { Address } from 'src/app/shared/model/address';

@Pipe({
  name: 'address',
  standalone: false
})
export class AddressPipe implements PipeTransform {

  transform(address: Address): string {
    let addressValue = '';
    addressValue += `${address.street.type} ${address.street.name}`;
    if (address.streetNumber) {
      addressValue += ` Nr ${address.streetNumber}`;
    }
    if (address.building) {
      addressValue += ` Bl ${address.building}`;
    }
    if (address.buildingEntry) {
      addressValue += ` Sc ${address.buildingEntry}`;
    }
    if (address.buildingFloor) {
      addressValue += ` Et ${address.buildingFloor}`;
    }
    if (address.buildingApartment) {
      addressValue += ` Ap ${address.buildingApartment}`;
    }
    return addressValue;
  }

}
